import { memo } from "react";

import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";

import { CheckboxField } from "@/components/ui/form/fields/check-box-field/check-box";

import { useDayTripPlanIsShowRoomForGuest } from "./hooks";

export const QuestionPlanIsShowRoomForGuest = memo(() => {
	const { isShowRoomForGuest, onSetIsShowRoomForGuest: _onSetIsShowRoomForGuest } =
		useDayTripPlanIsShowRoomForGuest();

	const onSetIsShowRoomForGuest = (input: boolean) => {
		_onSetIsShowRoomForGuest(input);
	};

	const label = "部屋の項目を表示する";
	const guide = `日帰りプランを予約する際、部屋の項目を表示することができます。<br />
		デフォルトの設定では日帰りプラン予約時、部屋という項目が予約の中で表示されなくなります。<br />
		日帰りプランで、部屋を提供される施設様はチェックを入れてください。<br />
		部屋の提供を行わない施設様は、在庫管理を行うためにダミーの部屋を用意してください。<br />`;

	return (
		<FeatureIslandCategoryQuestionForMain
			required={false}
			title={label}
			guide={guide}
			isEdited={isShowRoomForGuest.isEdited}
			hasError={Boolean(isShowRoomForGuest.error)}
			inputChildren={
				<CheckboxField
					value={isShowRoomForGuest.value}
					label={"日帰りプラン予約時、部屋の項目を表示する"}
					handleChange={onSetIsShowRoomForGuest}
					errorMessage={isShowRoomForGuest.error}
				/>
			}
		/>
	);
});

QuestionPlanIsShowRoomForGuest.displayName = "QuestionPlanIsShowRoomForGuest";
